// https://github.com/aws/aws-amplify/issues/678 fix: -->

if ((window as any).global === undefined) {
  (window as any).global = window;
}
if ((window as any).process === undefined) {
  (window as any).process = {
    env: { DEBUG: undefined },
  };
}

export {};
